import React from 'react'
import { PermissionList } from './list/page'

export const PermissionsPage: React.FC = () => {
  return <PermissionList />
}
